export default "__VITE_ASSET__h_PzTbFG__"